(function () {
    const favUrl = "/umbraco/surface/Favourites/";


    // Do not allow favouriting of the favourites page as this would require reinstantiating the list
    const list = document.querySelector(".fav-list");
    if (list) {
        const bc = list.closest("main").querySelector(".breadcrumb-wrapper")
        if (bc) {
            bc.querySelector(".fav-item").remove()
        }
    }

    document.addEventListener("click", (e) => {
        if (e.target.parentNode && e.target.parentNode.classList && e.target.parentNode.classList.contains("fav-item") && !e.target.parentNode.classList.contains("disabled")) {
            e.preventDefault()
            const id = e.target.parentNode.dataset.id
            const src = e.target.src;
            let url = favUrl
            if (src.includes("-outline")) {
                url += "AddFavourite/" + id
                e.target.src = e.target.src.replace("-outline", "").replace("white", "")
            } else {
                url += "RemoveFavourite/" + id
                let newImgSrcSuffix = "-outline"
                if (e.target.parentNode.classList.contains("darkbg")) {
                    newImgSrcSuffix += "white";
                }
                e.target.src = e.target.src.replace(".svg", newImgSrcSuffix + ".svg")
            }
            if (e.target.parentNode.classList.contains("remove")) {
                e.target.parentNode.classList.add("disabled")
                e.target.parentNode.closest(".item").addEventListener("animationend", () => {
                    const itemsEl = e.target.parentNode.closest(".items")
                    e.target.parentNode.closest(".item").remove()
                    if (itemsEl) {
                        if (itemsEl.querySelectorAll(".item").length == 0) {
                            itemsEl.closest(".cat").remove()
                        }
                    }
                })
                e.target.parentNode.closest(".item").classList.add("fade")
                e.target.parentNode.closest(".item").querySelector(".img").querySelector("img").classList.add("fade")
            }
            fetch(url)
                .then(resp => {
                    resp.json().then(data => {
                        window.memberFavourites = data
                        document.querySelectorAll(".fav").forEach(fav => {
                            fav.querySelector("span").innerText = data.length
                            if (data.length == 0) {
                                e.target.closest(".fav-list").querySelector("button.clear").remove()
                            }
                        })
                    })
                })
        }
    })

    document.querySelectorAll(".fav-list button.clear").forEach(btn => {

        btn.addEventListener("click", () => {
            btn.closest(".fav-list").querySelectorAll(".item").forEach(item => {
                item.addEventListener("animationend", () => {
                    const itemsEl = item.closest(".items")
                    item.remove()
                    if (itemsEl) {
                        if (itemsEl.querySelectorAll(".item").length == 0) {
                            itemsEl.closest(".cat").remove()
                        }
                    }
                })
                item.classList.add("fade")
                item.closest(".item").querySelector(".img").querySelector("img").classList.add("fade")
            })
            fetch(favUrl + "ClearFavourites").then(resp => {
                resp.json().then(data => {
                    window.memberFavourites = data
                    document.querySelectorAll(".fav").forEach(fav => {
                        fav.querySelector("span").innerText = data.length
                    })
                })
            })
            btn.closest(".fav-list").querySelector(".fav-send-content").innerHTML = btn.closest(".fav-list").querySelector(".nofavcontent").innerHTML;
            btn.remove()
        })
    })

    document.querySelectorAll(".fav-item").forEach(favEl => {
        if (favEl.dataset.pop && favEl.dataset.id) {
            const id = parseInt(favEl.dataset.id)
            const imgEl = document.createElement("img")
            imgEl.title = "favourite"
            imgEl.alt = ""
            imgEl.src = "/img/tourism/heart-16";
            if (!window.memberFavourites.includes(id)) {
                imgEl.src += "-outline"
                if (favEl.classList.contains("darkbg")) {
                    imgEl.src += "white";
                }
            }
            imgEl.src += ".svg"
            favEl.appendChild(imgEl)
        }
    })

    const favSentEl = document.querySelector(".fav-sent")
    if (favSentEl) {
        const yOffset = -400;
        const y = favSentEl.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });

    }

})();